import React from 'react';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const MedicationSourceReviewFallback = ({
  onAddMedication,
}) => (
  <Box
    sx={{
      mt: 0.9,
      p: 1,
      borderRadius: 1,
      bgcolor: alpha('#FFFFFF', 0.72),
      border: `1px solid ${alpha(colors.brand.tint, 0.2)}`,
    }}
  >
    <Typography sx={{ fontSize: '0.78rem', color: alpha(colors.semantic.ink, 0.72), lineHeight: 1.4 }}>
      Use the saved source text to enter the medication name, dose, and schedule in the medication list.
    </Typography>
    {onAddMedication ? (
      <Button
        size="small"
        variant="contained"
        onClick={() => onAddMedication()}
        sx={{
          mt: 0.85,
          borderRadius: '999px',
          px: 1.25,
          fontSize: '0.76rem',
          fontWeight: 850,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          boxShadow: 'none',
          bgcolor: colors.brand.deep,
          '&:hover': {
            bgcolor: colors.brand.ink,
            boxShadow: 'none',
          },
        }}
      >
        Add medication manually
      </Button>
    ) : null}
  </Box>
);

export default MedicationSourceReviewFallback;
